

export type DataWithTraits<T> = T & {
  isAdded: boolean;
  isEdited: boolean;
  isDeleted: boolean;
};

export interface TraitedData<T> {
  added: T[];
  edited: T[];
  deleted: T[];
}

export enum BrowserType {
  Chrome,
  IE,
  Edge,
  Firefox,
  Safari,
  Opera,
  Undefined,
}

export enum Environment {
  DEV = 'DEV',
  STAG = 'STAG',
  PROD = 'PROD',
}
